/** @format */
import dynamic from "next/dynamic";
import { Layout } from "../components/common/Layout";
const PrivacyPolicyWrapper = dynamic(() =>
  import("../components/PrivacyPolicy/PrivacyPolicyWrapper"), {ssr: false}
);

export default function PrivacyPolicy() {
  const meta = {
    title:
      "Qalara | Global sourcing & wholesale | Verified suppliers from India",
    description:
      "Join the community of wholesale buyers from UK, Canada, USA, Australia, Europe etc and sellers on Qalara - global sourcing platform for Indian handmade products",
    url: "/PrivacyPolicy/",
  };

  return (
    <Layout meta={meta}>
      <PrivacyPolicyWrapper />
    </Layout>
  );
}
